<template>
  <div id="app">
    <div class="wrapper">
      <div class="banner">
        <a href="https://www.pingan.com" class="logo" alt="中国平安"></a>
      </div>
      <div class="container">
        <div class="online-apply-box">
          <div class="tit tit-1"></div>
          <ul class="list">
            <li class="item" v-for="(i,j) in onlineList" :key="j">
              <a  @click="showEwm(i,j)" :otitle="i.des" otype="button" :data-event-param="i.des" :data-event-category="i.des" data-event-action="click">
                <img :src="i.img" :alt="i.des">
              </a>
              <div class="ewm-wraper" v-if="indx==i.id">
              <!-- <div class="ewm-wraper" v-if="true"> -->
                <qrcode :link="i.link" w="156" h="156"></qrcode>
                <div class="des">扫描二维码到手机查看</div>
                <span class="close" @click.stop="indx=!i.id"></span>
              </div>
            </li>
          </ul>
        </div>
        <div class="insurance-wraper">
          <div class="insurance-con">
            <span class="tit"></span>
            <p class="des">活动日期:6.23~6.30 每日10:00~11:00及16:00~17:00限时折扣</p>
            <ul class="insurance-list">
              <li class="insurance-item">
                <span class="label label-1"></span>
                <p class="counter-con" v-if="!(this.m==0 && this.s==0)">
                  <span class="des">限时抢购还剩</span>
                  <span class="timer">{{mFormat}}:{{sFormat}}分</span>
                </p>
                <a href="https://baoxian.pingan.com/product/gerenyiwaishanghaibaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="l" target="_blank"
                 otitle="周年庆狂欢-PC-产险楼层-平安个人意外保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-平安个人意外保险" data-event-category="周年庆狂欢-PC-产险楼层-平安个人意外保险" data-event-action="click">
                  <img src="./assets/accident-l.png" />
                </a>
                <div class="r">
                    <a href="http://baoxian.pingan.com/product/duanqiyiwaixian.shtml?WT.mc_id=20200618huodong-jtgw" class="r-item" target="_blank"
                    otitle="周年庆狂欢-PC-产险楼层-短期综合意外保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-短期综合意外保险" data-event-category="周年庆狂欢-PC-产险楼层-短期综合意外保险" data-event-action="click">
                      <img src="./assets/accident-r-1.png" >
                    </a>
                    <a href="https://baoxian.pingan.com/product/zhichangzongheyiliaobaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="r-item" target="_blank"
                     otitle="周年庆狂欢-PC-产险楼层-职场综合医疗保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-职场综合医疗保险" data-event-category="周年庆狂欢-PC-产险楼层-职场综合医疗保险" data-event-action="click">
                      <img src="./assets/accident-r-2.png" >
                    </a>
                </div>
              </li>

              <li class="insurance-item">
                <span class="label label-2"></span>
                <p class="counter-con"  v-if="!(this.m==0 && this.s==0)">
                  <span class="des">限时抢购还剩</span>
                  <span class="timer travel-timer">{{mFormat}}:{{sFormat}}分</span>
                </p>
                <a href="http://baoxian.pingan.com/product/guoneilvyoubaoxianzzy.shtml?WT.mc_id=20200618huodong-jtgw" class="l" target="_blank"
                otitle="周年庆狂欢-PC-产险楼层-国内自助旅游保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-国内自助旅游保险" data-event-category="周年庆狂欢-PC-产险楼层-国内自助旅游保险" data-event-action="click">
                  <img src="./assets/travel-l.png" />
                </a>
                <div class="r">
                    <a href="http://baoxian.pingan.com/product/yinhangkaanquanbaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="r-item" target="_blank"
                     otitle="周年庆狂欢-PC-产险楼层-银行卡安全保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-银行卡安全保险" data-event-category="周年庆狂欢-PC-产险楼层-银行卡安全保险" data-event-action="click">
                      <img src="./assets/travel-r-1.png" >
                    </a>
                    <a href="http://baoxian.pingan.com/product/quanqiujiaotongyiwaibaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="r-item" target="_blank"
                    otitle="周年庆狂欢-PC-产险楼层-全球交通意外保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-全球交通意外保险" data-event-category="周年庆狂欢-PC-产险楼层-全球交通意外保险" data-event-action="click">
                      <img src="./assets/travel-r-2.png" >
                    </a>
                </div>
              </li>

              <li class="insurance-item">
                <span class="label label-3"></span>
                <p class="counter-con"  v-if="!(this.m==0 && this.s==0)">
                  <span class="des">限时抢购还剩</span>
                  <span class="timer family-timer">{{mFormat}}:{{sFormat}}分</span>
                </p>
                <a href="http://baoxian.pingan.com/product/jiatingcaichanbaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="l" target="_blank"
                 otitle="周年庆狂欢-PC-产险楼层-家庭财产保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-家庭财产保险" data-event-category="周年庆狂欢-PC-产险楼层-家庭财产保险" data-event-action="click">
                  <img src="./assets/family-l.png" />
                </a>
                <div class="r">
                    <a href="http://baoxian.pingan.com/product/laonianrenzongheyiliaobaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="r-item" target="_blank"
                     otitle="周年庆狂欢-PC-产险楼层-中老年人综合医疗保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-中老年人综合医疗保险" data-event-category="周年庆狂欢-PC-产险楼层-中老年人综合医疗保险" data-event-action="click">
                      <img src="./assets/family-r-1.png" >
                    </a>
                    <a href="http://baoxian.pingan.com/product/ertongzongheyiliaobaoxian.shtml?WT.mc_id=20200618huodong-jtgw" class="r-item" target="_blank"
                    otitle="周年庆狂欢-PC-产险楼层-儿童综合医疗保险"  otype="button" data-event-param="周年庆狂欢-PC-产险楼层-儿童综合医疗保险" data-event-category="周年庆狂欢-PC-产险楼层-儿童综合医疗保险" data-event-action="click">
                      <img src="./assets/family-r-2.png" >
                    </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="product-wrapper">
          <ul class="product-list">
            <li class="item" v-for="(item, index) in proList.slice(0,5)" :key="item.id">
              <a  @click="scanEwm(item,index)" :otitle="item.des"  otype="button" :data-event-param="item.des" :data-event-category="item.des" data-event-action="click" v-if="index!=1">
                <img :src="item.img">
              </a>
              <a  href="https://baoxian.pingan.com/pa18shopnst/new/activity/20200618/index.html?WT.mc_id=20200618huodong-jtgw" target="_blank" @click="scanEwm(item,index)" :otitle="item.des" otype="button" :data-event-param="item.des" :data-event-category="item.des" data-event-action="click">
                <img :src="item.img"  v-if="index==1">
              </a>
              <div class="ewm-wraper" v-if="current == item.id && index!=1">
                <qrcode :link="item.link"  w="100" h="100" ref='qrcode' @close="closeEwm" v-if="index!=3"></qrcode>
                <img src="./assets/ewm.png" class="ewm-img" v-if="index==3"/>
                <div class="des">扫描二维码到手机查看</div>
                <span class="close" @click.stop="current=!item.id"></span>
              </div>
            </li>
            <li class="item" v-for="(item, index) in proList.slice(5,6)" :key="item.id">
              <a  href='https://www.pingan.com/official/activitylist?v=20200424' target="_blank" @click="scanEwm(item,index)" :otitle="item.des" otype="button" :data-event-param="item.des" :data-event-category="item.des" data-event-action="click">
                <img :src="item.img" >
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>

<script>
import { statistics, webTrends } from './utils/statistics';
import qrcode from './components/ewm';
import p1 from './assets/p1.png';
import p2 from './assets/p2.png';
import p3 from './assets/p3.png';
import s1 from './assets/s1.png';
import s2 from './assets/s2.png';
import s3 from './assets/s3.png';
import s4 from './assets/s4.png';
import s5 from './assets/s5.png';
import s6 from './assets/s6.png';

export default {
  name: 'App',
  components: {
    qrcode
  },
  data() {
    return {
      current: 0,
      indx: 0,
      onlineList: [
        {
          id: '001',
          img: p1,
          des: '周年庆狂欢-PC-产品预约-全能英才',
          link: 'https://m.pingan.com/c3/huodong/yyqnyc.html'
        },
        {
          id: '002',
          img: p2,
          des: '周年庆狂欢-PC-产品预约-金瑞人生',
          link: 'https://m.pingan.com/c3/huodong/yyjrrs.html'
        },
        {
          id: '003',
          img: p3,
          des: '周年庆狂欢-PC-产品预约-福泽安康',
          link: 'https://m.pingan.com/c3/huodong/yyfzak.html'
        }
      ],
      proList: [
        {
          id: 1,
          img: s1,
          des: '周年庆狂欢-PC-活动位置-移动首页',
          link: 'https://m.pingan.com/c3/huodong/2020pacelebration.html'
        },
        {
          id: 2,
          img: s2,
          des: '周年庆狂欢-PC-活动位置-618惊喜专场',
          link: 'https://baoxian.pingan.com/pa18shopnst/new/activity/20200618/index.html'
        },
        {
          id: 3,
          img: s3,
          des: '周年庆狂欢-PC-活动位置-嗨翻星期五',
          link: 'https://m.pingan.com/c3/huodong/yyhd.html'
        },
        {
          id: 4,
          img: s4,
          des: '周年庆狂欢-PC-活动位置-微平安0元领',
          link: ''
        },
        {
          id: 5,
          img: s5,
          des: '周年庆狂欢-PC-活动位置-许愿池有好礼',
          link: 'https://m.pingan.com/c3/huodong/bestwishs2020.html'
        },
        {
          id: 6,
          img: s6,
          des: '周年庆狂欢-PC-活动位置-查看更多',
          link: 'https://pingan.com/official/activitylist?v=20200424'
        }
      ],
      minDate: 23,
      maxDate: 30,
      am: 10, // 10-11
      pm: 16, // 16-17
      m: '',
      s: '',
      showCounter: false
    };
  },
  methods: {
    showEwm(item, index) {
      this.current = 0;
      this.indx = item.id;
    },
    scanEwm(item, index) {
      this.indx = 0;
      this.current = item.id;
      // if (this.$refe.qrcode && this.$refs.qrcode[0]) {
      //   console.log('qrcode', this.$refs);
      //   this.$refs.qrcode[0].qrcode(item.link);
      // }
    },
    closeEwm(id) {
      this.current = !id;
    },
    goH5() {
      let baseUrl = '';
      if (process.env.NODE_ENV === 'production') {
        baseUrl = '//m.pingan.com/c3/huodong/2020pacelebration.html';
      } else {
        baseUrl = '//stg5.pingan.com.cn:60880/pacms/c3/huodong/2020pacelebration.html';
      }
      if (/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))) {
        try {
          if (/Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            window.location.href = baseUrl;
          } else if (/iPad/i.test(navigator.userAgent)) {
            window.location.href = baseUrl;
          } else {
            window.location.href = baseUrl;
          }
        } catch (e) {
          console.log(e.message);
        }
      }
    },
    timerDown() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let time = ''; //time: 11:00:00  17:00:00
      let endTime = '';
      let curTime = new Date().getTime();
      let distance = '';
      if (yy === 2020 && mm === 6 && (dd >= 23 && dd <= 30)) {
        if (hh === 10) {
          time = '11:00:00';
        }
        if (hh === 16) {
          time = '17:00:00';
        }
        endTime = new Date(`${yy}/${mm}/${dd} ${time}`).getTime();
        distance = (endTime - curTime) / 1000;
        if (distance > 0) {
          this.m = Math.floor(distance / 60);
          this.s = Math.floor(distance % 60);
          if (this.m === 0 && this.s === 0) {
            this.m = 0;
            this.s = 0;
            this.showCounter = false;
          }
          console.log(this.m, this.s);
        } else {
          this.m = 0;
          this.s = 0;
          this.showCounter = false;
        }
      }
    }
  },
  computed: {
    lastList() {
      return this.proList.slice(5, 6);
    },
    mFormat() {
      if (this.m < 10) {
        return `0${this.m}`;
      } else {
        return this.m;
      }
    },
    sFormat() {
      if (this.s < 10) {
        return `0${this.s}`;
      } else {
        return this.s;
      }
    }
  },
  created() {
    let timer = setInterval(() => {
      this.timerDown();
    }, 1000);
  },
  mounted() {
    statistics();
    webTrends();
    this.goH5();
  }
};
</script>

<style lang="less">
body{
  font-family: 'Microsoft Yahei', sans-serif, Arial, 'Simsun' !important;
}
*{
  padding:0;
  margin:0;
}
li{
  list-style-type:none;
}
.wrapper{
  min-width:1200px;
  max-width:1920px;
  width:100%;
  margin:0 auto;
  .logo{
    display:block;
    width:1100px;
    height:34px;
    margin:0px auto;
    background:url('./assets/PA-logo.png') no-repeat center 0;
    // background-size:cover;
    padding-top:10px;
  }
  .banner{
    width:100%;
    height:456px;
    background:url("./assets/bg.png") no-repeat center top;
    padding-top:20px;
    box-sizing:border-box;
  }
  .container{
    width:100%;
    // height:456px;
    background:url("./assets/bg2.png") no-repeat center top;
    padding-top:30px;
    .online-apply-box{
      position:relative;
      width:1100px;
      height: 405px;
      margin:0 auto;
      background: #243E89;
      border-radius: 10px;
      padding-top:60px;
      box-sizing:border-box;
      .tit{
        position: absolute;
        top:-34px;
        left:50%;
        margin-left:-419px;
        width:839px;
        height: 68px;
        color:#fff;
        font-size:34px;
        text-align:center;
        line-height:68px;
      }
      .tit-1{
        background:url(./assets/tit-1.png) no-repeat center top;
        top:-13px;
      }
      .list{
        padding-left:20px;
        padding-top:10px;
        box-sizing:border-box;
        .item{
          position: relative;
          width:340px;
          height: 306px;
          // background: rgba(0,0,0,0.50);
          border-radius: 10px;
          display:inline-block;
          margin-right:20px;
          clear: both;
          a{
            // display:block;
            width:100%;
            height:100%;
            border-radius:8px;
            outline:none;
            border:0;
            cursor: pointer;
            img{
              display: block;
              width:100%;
              height:100%;
              border:0;
            }
          }
          .ewm-wraper{
            position: absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            background:rgba(0,0,0,0.8);
            border-radius:8px;
            text-align:center;
            .close{
              position: absolute;
              right:8px;
              top:5px;
              display:inline-block;
              width:18px;
              height: 18px;
              background:url(./assets/close.png) no-repeat center top;
              cursor: pointer;
            }
            .qrcode{
              width:184px;
              height:184px;
              border-radius: 8px;
              background:#fff;
              padding:15px 5px 5px 5px;
              margin:40px auto 0 auto;
              box-sizing:border-box;
              text-align:center;
              img{
                width:156px;
                height:156px;
                margin:0 auto;
              }
            }
            .des{
              margin-top:18px;
              color:#fff;
              font-size:20px;
              text-align:center;
            }
          }
        }
      }
    }
    .product-wrapper{
      overflow:hidden;
      background:url("./assets/bg3.png") no-repeat center top;
      .product-list{
        width:1100px;
        // height:780px;
        margin:20px auto 0 auto;
        clear: both;
        .item{
          position: relative;
          display:inline-block;
          margin-bottom:24px;
          width:538px;
          height:220px;
          a {
            display:inline-block;
            width:100%;
            // height:100%;
            border-radius:8px;
            outline:none;
            border:0;
            cursor:pointer;
            img{
              display:inline-block;
              width:100%;
              height:100%;
              border-radius:8px;
              border:0;
            }
          }
          .ewm-wraper{
            position: absolute;
            top:0;
            left:0;
            width:100%;
            height:220px;
            background:rgba(0,0,0,0.8);
            border-radius:8px;
            .close{
              position: absolute;
              right:8px;
              top:5px;
              display:inline-block;
              width:18px;
              height: 18px;
              background:url(./assets/close.png) no-repeat center top;
              cursor: pointer;
            }
            .qrcode{
              float:left;
              margin-left:72px;
              margin-top:20px;
              width:174px;
              height: 174px;
              background:#fff;
              border-radius:8px;
              padding:12px;
              box-sizing:border-box;
              img{
                width:100%;
                height:100%;
              }
            }
            .des{
              float:left;
              color:#fff;
              font-size:20px;
              margin-left:34px;
              margin-top:100px;
            }
          }
        }
        .item:nth-child(odd){
          float:left;
          width:538px;
          height:219px;
          margin-right:24px;
        }
        .ewm-img{
          display:block;
          width:174px;
          height:174px;
          float: left;
          margin-left: 72px;
          margin-top: 20px;
          background: #fff;
          border-radius: 8px;
          padding: 12px;
          box-sizing: border-box;
        }
      }
    }
  }
  .insurance-wraper{
    width:100%;
    // height:1168px;
    background:url(./assets/insurance-bg.png) no-repeat center top;
    // background:#120B64;
    position:relative;
    padding-bottom:20px;
    overflow: hidden;
    background-size:cover;
    .tit-2{
      width:840px;
      height: 68px;
      background:url(./assets/tit-2.png) no-repeat center top;
    }
    .insurance-item{
      position:relative;
      width:1060px;
      height:333px;
      margin:10px auto;
      background: #3454AB;
      border-radius: 10px;
      padding:61px 0 0 20px;
      box-sizing:border-box;
      .label{
        position:absolute;
        left:0;
        top:0;
        display:inline-block;
        width:190px;
        height: 45px;
      }
      .label-1{
        background:url(./assets/accident-tit.png) no-repeat center top;
      }
      .label-2{
        background:url(./assets/travel-tit.png) no-repeat center top;
      }
      .label-3{
        background:url(./assets/family-tit.png) no-repeat center top;
      }
      .counter-con{
        position:absolute;
        right:20px;
        top:12px;
        .des{
          color:#fff;
          font-size:16px;
          margin-right:5px;
        }
        .timer{
          display:inline-block;
          width:90px;
          height:29px;
          line-height:29px;
          background-image: linear-gradient(-180deg, #FFFFD6 0%, #FFE3A0 100%);
          border-radius:4px;
          text-align:center;
          color:#243E89;
          font-size:18px;
        }
        .travel-timer{
          background-image: linear-gradient(-180deg, #D3FFFA 0%, #A0FDFF 100%);
        }
        .family-timer{
          background-image: linear-gradient(-180deg, #F3EDFF 0%, #DBA0FF 100%);
        }
      }
      .l{
        display:block;
        width:470px;
        height:254px;
        float:left;
        margin-right:20px;
      }
      .r{
        float:left;
        .r-item{
          display:block;
          width:530px;
          height:118px;
          margin-bottom:18px;
        }
      }
      img{
        border:0;
      }
    }
  }
  .insurance-con{
    width:1100px;
    // height:1168px;
    margin:30px auto 0;
    background:#243E89;
    border-radius:10px;
    position: relative;
    padding:80px 0 10px;
    box-sizing:border-box;
    .tit{
      position:absolute;
      left:50%;
      top:-15px;
      margin-left:-420px;
      display:block;
      width:840px;
      height:648px;
      background:url(./assets/tit-2.png) no-repeat center top;
    }
    .des{
      color:#fff;
      font-size:18px;
      text-align:center;
      height:40px;
    }
  }
  .footer{
    width:100%;
    height: 190px;
    background:url(./assets/footer.png) no-repeat center top;
    background-size:cover;
   }
}
</style>
